import { Box, Button, Card, Grid, TableCell, TableContainer, TableRow, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router';
import { useState } from 'react';
import api from "../../../components/services/api";
import Swal from 'sweetalert2';

export default function Plan() {
  const history = useHistory();
  const { voyNo } = useParams()

  // const [bay, setBay] = useState(null)
  const [bogie, setBogie] = useState(null)
  // const [row, setRow] = useState(null)
  // const [tier, setTier] = useState(null)
  const [table, setTable] = useState(null)
  const [dataC, setDataC] = useState([])
  const [loading, setLoading] = useState(true)


  function findBay(max, n) {
    if (max % 2 == 0) {
      if (n >= max / 2) {
        return (n - (max / 2)) * 2 + 1
      } else {
        return max - (n * 2)
      }
    } else {
      if (n >= (max - 1) / 2) {
        return (n - ((max - 1) / 2)) * 2 + 1
      } else {
        return (max - 1) - (n * 2)
      }
    }
  }

  const gentable = (bogie, dataC) => {
    let tbl = []
    let data = [];
    // let size = dataC?.ContainerList?.filter((x) => x.Size === '40').map((x) => ({ ...x, Row: +x.Row + 1  }))
    // dataC?.ContainerList?.push(...size)
    for (let b = 0; b < parseInt(bogie); b++) {
        
            const item = dataC?.ContainerList?.filter((x) => x?.Bogie === b+1)

            data.push(<>
              <Tooltip arrow title={item?.length === 0 ? '' : `Container No. ${item?.map(x => (x?.ContainerId))}`} placement="top">
                <Box sx={{
                  width:'200px',
                  height:'100px',
                  background: item?.length === 0 ? '#00cf00' : item?.length === 1 ? '#0014ff' : '#ff0000', cursor: 'pointer', position: 'relative',
                  ':hover': {
                    WebKitFilter: 'grayscale(100%)',
                    filter: 'brightness(.5)'
                  }
                }}></Box>
              </Tooltip></>);
      tbl.push(
        <Box sx={{ display: 'flex', flexDirection:'column', alignItems: 'center', marginRight:'20px' }}>
          <Box sx={{ padding: '20px', width: 'fit-content' }}>{data}</Box>
          <Typography>{b + 1}</Typography>
        </Box>);
      data = []
    }
    setTable(tbl)
  }
  const getData = async () => {
    const res = await api.get(`api/train/detail/planzone/${voyNo}`)
    const data = await res.data
    if (res.meta.status === true) {
      setBogie(data.Bogie)
      setDataC(data)
      // setBay(data.Bay)
      // setRow(data.Row)
      // setTier(data.Tier)
      if (data.Bogie) {
        gentable(data.Bogie, data)
        setLoading(false)
      }
    }


  }
  useEffect(() => {
    getData()
  }, [])

  const handleSave = async () => {
    const body = {
      VoyNo: voyNo,
      Bogie: bogie,
    }
    const res = await api.post(`api/train/update/planzone`, body)
    const data = await res.data
    if (res.meta.status) {
      Swal.fire({
        title: `${res.meta.message}`,
        icon: 'success',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          getData()
        }
      })
    }
  }

  return (
    <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
      <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
        วางแผน
      </h6>

      <Grid container alignItems="center" spacing={1}>
        <Grid item xs>
          <Typography
            className="textcolordarkblue"
            variant="h5"
            component="h1"
          >
            PLAN #{voyNo}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", flexDirection: "row" }}>
          <Typography className="textcolorBule">
            ShipSchedule{" "}
          </Typography>
          <Typography>
            <span>&nbsp;</span> / Plan
          </Typography>
        </Grid>
      </Grid>
      <Grid
        //   container
        //   sx={{ justifyContent: "end" }}
        style={{ marginTop: "10px", display: "flex", flexDirection: 'column' }}
      >
        <Grid container>
          <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={bogie}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setBogie(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="bogie" variant="outlined" size='small' />
          </Grid>
          {/* <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={row}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setRow(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="Row" variant="outlined" size='small' />
          </Grid>
          <Grid xs={3} sx={{ marginRight: "15px" }}>
            <TextField value={tier}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }} onChange={(e) => setTier(e.target.value)} InputLabelProps={{ shrink: true }}
              fullWidth label="Tier" variant="outlined" size='small' />
          </Grid> */}
          {/* <Grid xs={2} sx={{ marginRight: "15px" }}>
            <Button
              onClick={() => gentable(bogie, dataC)}
              variant='contained'
              disabled={bogie ? false : true}
              style={{
                color: bogie ? "#fff" : "#adb5bd",
                background: bogie ? "#80c340" : "#e9ecef",
                borderColor: bogie ? "#80c340" : "#e9ecef",
                marginRight: "10px",
              }}
            >
              confirms
            </Button>
          </Grid> */}
        </Grid>
        <Box
          sx={{
            width: "100%",
            marginTop: "10px",
            paddingBottom: "24px",
          }}
        >
          <Button
            type="button"
            variant="outlined"
            style={{
              color: "#80c340",
              borderColor: "#80c340",
              marginRight: "10px",
            }}
            onClick={history.goBack}
          >
            back
          </Button>
          {bogie ? 
          <Button
            type="button"
            variant="contained"
            style={{
              color: "#fff",
              background: "#80c340",
              marginRight: "10px",
            }}
            onClick={handleSave}
          >
            save
          </Button>
          : null }

        </Box>

        <Box sx={{width:'100%', overflowX:'auto'}}>
          {loading ? 'Loading...' : <Box sx={{display:'flex'}}>{table}</Box>} 
        </Box>
      </Grid>
    </Card>
  )
}
